import { useEffect, useState } from "react";

// Observe the real sticky boundary, including the Places subnav offset.
// The sticky shell remains outside the horizontal clip/scroll ancestors.
export function useListHeaderStuck({ sentinelRef, headerScrollRef, enabled = true, invalidate }) {
  const [isStuck, setIsStuck] = useState(false);
  useEffect(() => {
    setIsStuck(false);
    const sentinel = sentinelRef.current;
    const shell = headerScrollRef.current?.parentElement;
    if (!enabled || !sentinel || !shell || typeof IntersectionObserver === "undefined") return undefined;
    const top = Number.parseFloat(getComputedStyle(shell).top) || 0;
    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(!entry.isIntersecting
        && entry.boundingClientRect.top < (entry.rootBounds?.top ?? top)),
      { root: sentinel.closest(".v2-content"), rootMargin: `-${top}px 0px 0px 0px`, threshold: [1] },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [sentinelRef, headerScrollRef, enabled, invalidate]);
  return isStuck;
}
